/**
 * Function for create library objects for prepareVue CmsVue
 * @param obj
 * @param instanceName
 * @param isConstructor
 * @param libraryOpts
 * @param constructorOpts
 * @return {{instanceName, obj, isConstructor: boolean, libraryOpts: {}, constructorOpts: {}}}
 */
export function cmsVueLibrary(obj, instanceName, isConstructor = false, libraryOpts = {}, constructorOpts = {}) {
  return {
    obj,
    instanceName,
    isConstructor,
    libraryOpts,
    constructorOpts,
  };
}
